module.exports = __webpack_public_path__ + "static/media/italy.f04de15f.svg";